import { Page } from 'components/layout/page/Page';

const Index = () => {
  return <Page />;
};

export default Index;
